var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    "cv-header-panel",
    (_vm.carbonPrefix + "--header-panel"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--header-panel--expanded")] = _vm.panelExpanded, _obj ) ],attrs:{"aria-hidden":!_vm.panelExpanded ? 'true' : 'false',"id":_vm.id},on:{"focusout":_vm.onFocusout,"mousedown":_vm.onMouseDown}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }